export const horizontalChartOptions = {
    axisY: {
        showLabel: true,
        offset: 60,
        position: 'start'
      },
    axisX: {
        onlyInteger: true,
        offset: 0
    },
    chartPadding: {
        top: 0,
        right: 20,
        bottom: 0,
        left: 50
    },
    showArea: true,
    horizontalBars: true,
    fullWidth: true,
}

export const verticalChartOptions = {
    axisY: {
        showLabel: true,
        offset: 50,
        position: 'start'
    },
    axisX: {
        onlyInteger: true,
        offset: 60,
    },
    chartPadding: {
        top: 50,
        right: 20,
        bottom: 10,
        left: 20
    },
    low: 0
}